import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import ComponentListItem from './ComponentListItem'
import ComponentListBackground from './ComponentListBackground'
import ComponentListLogo from './ComponentListLogo'
import AdditionalInfo from './AdditionalInfo'
import GroupedComponent from './GroupedComponent'
import { hoverList } from '../utils/settings'
import ToggleableComponent from './ToggleableComponent'
import {
  backgroundClicked,
  closePopover,
  componentClicked,
  componentHovered,
  componentToggle,
  componentHighlighted,
  componentUnhighlighted,
  logoClicked,
  specificationClick
} from '../actions'
import { getChoice } from '../utils/bike-config'
import { getBaseModel, getMenuGroups } from '../utils/bike-schema'
import { State } from 'shared'

type DataType = {
  component: any
  active: boolean
  option: any
  hex: string
}[]

type ComponentListType = {
  active: boolean
  component: any
  hex: string
  id: string
  option: any
}[]
const getGroupComponents = (data: DataType) => {
  const menuGroups = getMenuGroups()
  const componentList: ComponentListType = data.map((unit) => {
    return { id: unit.component.id, ...unit }
  })

  const groupedData = menuGroups.map((menuGroup) => {
    let found: ComponentListType = []
    menuGroup.options.forEach((option) => {
      componentList.find((item) => {
        if (item.id === option) {
          found.push(item)
        }
      })
    })
    return { ...menuGroup, found }
  })
  return groupedData
}

const handleClick = (id, hoverA, clickA): void => {
  !!hoverList.find((opt) => opt === id) && window.innerWidth > 768
    ? hoverA(id)
    : clickA(id)
}

const ComponentList: React.FC = () => {
  const dispatch = useDispatch()

  const bikeConfig = useSelector((state: State) => state.bikeConfig)
  const specifications = useSelector((state: State) => state.specifications)
  const specification = useSelector((state: State) => state.specification)
  const popover = useSelector((state: State) => state.popover)
  const options = useSelector((state: State) => state.options)
  const optionColor = useSelector((state: State) => state.optionColor)

  const baseModel = getBaseModel(bikeConfig.baseModelId)
  const baseModelId = bikeConfig.baseModelId
  let logoUrl: string = ''
  let components: any = []
  baseModel?.components.forEach((component) => {
    const choice = getChoice(bikeConfig, component)
    if (component.hidden !== true)
      components.push({
        component,
        active:
          (popover === 'options' && options.componentId == component.id) ||
          (popover === 'optionColor' &&
            optionColor.componentId == component.id),
        option: choice && choice.option,
        hex:
          choice &&
          ((choice.color && choice.color.hex) || choice.option.swatch_color)
      })
    if (!logoUrl && choice.logo) {
      logoUrl = choice.logo
    }
  })

  const groupedComponents = getGroupComponents(components)

  return (
    <div className="velorbis-customizer-component-list">
      {groupedComponents.map((groupedComponent) => {
        return !groupedComponent.toggle ? (
          <GroupedComponent
            key={groupedComponent.id}
            name={groupedComponent.name}
            count={groupedComponent.found.length}
          >
            {groupedComponent.found.map((item) => {
              return (
                <ComponentListItem
                  key={item.component.id}
                  {...item}
                  closePopover={() => dispatch(closePopover())}
                  onClick={() =>
                    handleClick(
                      item.component.id,
                      (id: string) => dispatch(componentHovered(id)),
                      (id: string) => dispatch(componentClicked(id))
                    )
                  }
                  onMouseEnter={() =>
                    dispatch(componentHighlighted(item.component.id))
                  }
                  onMouseLeave={() => dispatch(componentUnhighlighted())}
                  specificationClick={(id) => dispatch(specificationClick(id))}
                />
              )
            })}
          </GroupedComponent>
        ) : (
          <ToggleableComponent
            name={groupedComponent.name}
            key={groupedComponent.id}
            componentToggle={() => dispatch(componentToggle())}
          />
        )
      })}
      {!baseModelId.startsWith('urban') && ( // TODO: Implement multi angled logo placement
        <GroupedComponent name={'logo_select'} count={1}>
          <ComponentListLogo
            active={popover === 'logo'}
            logoUrl={logoUrl}
            onClick={() => dispatch(logoClicked())}
          />
        </GroupedComponent>
      )}
      <GroupedComponent name={'background_select'} count={1}>
        <ComponentListBackground
          active={popover === 'background'}
          background={bikeConfig.background}
          onClick={() => dispatch(backgroundClicked())}
        />
      </GroupedComponent>
      <GroupedComponent name={'additional_info'} count={1}>
        <AdditionalInfo
          specifications={specifications}
          specificationClick={(id: string) => dispatch(specificationClick(id))}
          specification={specification}
        />
      </GroupedComponent>
    </div>
  )
}

export default ComponentList
